import styles from "./acardeon.module.css";
import { useMeals, useMealsAction } from "../../../../Context/MealsProvider";
import { AiOutlinePlus } from "react-icons/ai";
const AcardeonGashtha = ({ index, dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();

  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}-${dayIndex}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  return (
    <div className="accordion " id={`#parent-accordion-${index}-${dayIndex}`}>
      <div
        className={`btn ${styles.btnacardeon}`}
        onClick={toggleAccordion}
        type="button"
      >
        <AiOutlinePlus />
      </div>

      <div
        className="accordion-collapse collapse"
        id={`accordion-${index}-${dayIndex}`}
        data-bs-parent={`#parent-accordion-${index}-${dayIndex}`}
      >
        <div style={{ marginTop: "22px" }}>
          <div className={styles.containerAcardeon1}>
            <div className={styles.containerMain}>
              <div className={styles.formInput}>
                <p className={styles.text}>توضیحات</p>
                <textarea
                  type="text"
                  className={styles.inputBoxbig}
                  value={meals[dayIndex][index].description}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerDesc",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcardeonGashtha;
